import {useMemo} from 'react'
import {resolveAgentProfile} from '../agents/resolve-agent-profile'
import {AgentProfileContext} from './agent-profile-context'

interface AgentProfileProviderProps {
  /** The agent slug used to resolve the profile. */
  slug?: string
  children: React.ReactNode
}

/**
 * Provides a resolved AgentProfile to the component tree.
 *
 * Resolves the profile by looking up the slug in the profile registry.
 * Place this provider above components that need agent-type-aware behavior
 * (SessionHeader, SessionLogs, TaskChat input area, etc.).
 */
export function AgentProfileProvider({slug, children}: AgentProfileProviderProps) {
  const profile = useMemo(() => resolveAgentProfile(slug), [slug])

  return <AgentProfileContext value={profile}>{children}</AgentProfileContext>
}
